import { Component, OnInit, Input } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { PaymentPlanDefaults } from './model/payment-plan';
import { PaymentHubService } from './service/payment-hub.service';

@Component({
  selector: 'payment-hub',
  templateUrl: './payment-hub.component.html',
  styleUrls: ['./payment-hub.component.css'],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }]
})
export class PaymentHubComponent implements OnInit {

  constructor(private router: Router, private paymentHubService: PaymentHubService) {
    this.paymentHubData = undefined;
    this.amount = 0;
    this.tab = 2;
  }

  amount: number;
  tab: number;
  paymentHubData: any;
  payloadData: any;
  defaultSettings: any;
  keypadType: string;

  private isCollectJsPresent = false;

  @Input() suppliedPaymentHubData: any;
  @Input() suppliedPayloadData: any;

  private collectJsCss = '{"border-width": "0px","text-align": "center","padding-left": "5px","color": "#454545"}';

    ngOnInit(): void {
        this.loadDefaults(localStorage.getItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID));
        this.onTabClick(1);
        this.paymentHubData = this.suppliedPaymentHubData;
        this.payloadData = this.suppliedPayloadData;
        this.amount = this.getAmountDue(this.paymentHubData);
    }

  getAmountDue(payhubdata: any) {
    let totalAmountDue = 0;

    payhubdata.customers.map(function(customer) {
      customer.accounts.map(function(account) {
        account.invoices.map(function(invoice) {
          totalAmountDue = totalAmountDue + invoice.amountDue;
        });
      });
    });
    return totalAmountDue;
  }

  onTabClick(tab: any) {
    switch (tab) {
      case 1:
        this.router.navigate(['/customer/payment']);
        break;
      case 2:
        this.router.navigate(['/customer/wallet']);
        break;
      case 3:
        this.router.navigate(['/customer/recurring']);
        break;
      default:
        this.router.navigate(['/customer']);
        break;
    }
    this.tab = tab;
  }


  private loadDefaults(transactionId: string) {
    this.paymentHubService.defaults(transactionId).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }

      this.defaultSettings = res.body;
      this.keypadType = this.defaultSettings.settings.keypadType;

      this.loadCollectJsScript(this.defaultSettings.settings.jsAPIkey);
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  }


  loadCollectJsScript(apiKey: string) {
        return new Promise((resolve, reject) => {
            if (!this.isCollectJsPresent) {
                // load script
                const script: any = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://secure.networkmerchants.com/token/Collect.js';
                script.setAttribute('data-tokenization-key', apiKey);
                script.setAttribute('data-custom-css', JSON.stringify(this.collectJsCss));
                if (script.readyState) {  // IE
                    script.onreadystatechange = () => {
                        if (script.readyState === 'loaded' || script.readyState === 'complete') {
                            script.onreadystatechange = null;
                            this.isCollectJsPresent = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                } else {  // Others
                    script.onload = () => {
                        this.isCollectJsPresent = true;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
                document.getElementsByTagName('head')[0].appendChild(script);
            } else {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
        });
    }

    adminUserWithKeypadEnabled() {
        return this.defaultSettings.admin && this.defaultSettings.settings.adminKeypadEnabled;
    }
}
